// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ConnectorIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ConnectorIcon" ref={forwardedRef} {...props}>
      <path d="m14.712 3.8.01.01a3 3 0 0 0-4.18.061l-2.12 2.122.89.89-1.225 1.225 1.237 1.237 1.225-1.224 1.06 1.059-1.231 1.23 1.237 1.238 1.23-1.231.88.879 2.12-2.121a3 3 0 0 0 .063-4.18l.042.043 2-2L16.712 1.8zm.073 2.193a1.5 1.5 0 0 1 0 2.121l-1.06 1.06-3.182-3.181 1.06-1.061a1.5 1.5 0 0 1 2.122 0z" />
      <path d="m4.987 15.99-.022-.022a3 3 0 0 0 4.15-.09l2.12-2.12-5.302-5.304-2.122 2.121a3 3 0 0 0-.062 4.179L1.75 16.753l1.237 1.237zm-.115-2.233a1.5 1.5 0 0 1 0-2.12l1.06-1.062 3.183 3.182-1.061 1.061a1.5 1.5 0 0 1-2.121 0z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ConnectorIcon = /* @__PURE__ */ Object.assign(
  ConnectorIconComponent,
  { displayName: 'ConnectorIcon' },
);
